'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticField = function (_AbstractField) {
    (0, _inherits3.default)(StaticField, _AbstractField);

    function StaticField() {
        (0, _classCallCheck3.default)(this, StaticField);
        return (0, _possibleConstructorReturn3.default)(this, (StaticField.__proto__ || (0, _getPrototypeOf2.default)(StaticField)).apply(this, arguments));
    }

    (0, _createClass3.default)(StaticField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                addonsBefore = _props.addonsBefore,
                inputClass = _props.inputClass,
                children = _props.children,
                addonsAfter = _props.addonsAfter,
                props = (0, _objectWithoutProperties3.default)(_props, ['addonsBefore', 'inputClass', 'children', 'addonsAfter']);

            var field = _react2.default.createElement(
                'div',
                props,
                children
            );

            return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        }
    }]);
    return StaticField;
}(_AbstractField3.default);
/**
 * Field se statickým vlastním pbsahem, který je uveden jako children.
 */


exports.default = StaticField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvU3RhdGljRmllbGQuanN4Il0sIm5hbWVzIjpbIlN0YXRpY0ZpZWxkIiwicHJvcHMiLCJhZGRvbnNCZWZvcmUiLCJpbnB1dENsYXNzIiwiY2hpbGRyZW4iLCJhZGRvbnNBZnRlciIsImZpZWxkIiwicmVuZGVyRmllbGRXaXRoQWRkb25zIiwiQWJzdHJhY3RGaWVsZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBSUE7Ozs7QUFDQTs7QUFDQTs7Ozs7O0lBR01BLFc7Ozs7Ozs7Ozs7aUNBRU87QUFBQSx5QkFDK0QsS0FBS0MsS0FEcEU7QUFBQSxnQkFDRUMsWUFERixVQUNFQSxZQURGO0FBQUEsZ0JBQ2dCQyxVQURoQixVQUNnQkEsVUFEaEI7QUFBQSxnQkFDNEJDLFFBRDVCLFVBQzRCQSxRQUQ1QjtBQUFBLGdCQUNzQ0MsV0FEdEMsVUFDc0NBLFdBRHRDO0FBQUEsZ0JBQ3NESixLQUR0RDs7QUFFTCxnQkFBTUssUUFBUTtBQUFBO0FBQVNMLHFCQUFUO0FBQ1RHO0FBRFMsYUFBZDs7QUFJQSxtQkFBTyxLQUFLRyxxQkFBTCxDQUEyQkQsS0FBM0IsRUFBa0NKLFlBQWxDLEVBQWdERyxXQUFoRCxDQUFQO0FBQ0g7OztFQVRxQkcsdUI7QUFSMUI7Ozs7O2tCQW1CZVIsVyIsImZpbGUiOiJTdGF0aWNGaWVsZC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vKipcbiAqIEZpZWxkIHNlIHN0YXRpY2vDvW0gdmxhc3Ruw61tIHBic2FoZW0sIGt0ZXLDvSBqZSB1dmVkZW4gamFrbyBjaGlsZHJlbi5cbiAqL1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7SW5wdXR9IGZyb20gJ3JlYWN0c3RyYXAnO1xuaW1wb3J0IEFic3RyYWN0RmllbGQgZnJvbSBcIi4vQWJzdHJhY3RGaWVsZFwiO1xuXG5cbmNsYXNzIFN0YXRpY0ZpZWxkIGV4dGVuZHMgQWJzdHJhY3RGaWVsZCB7XG5cbiAgICByZW5kZXIoKSB7XG4gICAgICAgIGNvbnN0IHthZGRvbnNCZWZvcmUsIGlucHV0Q2xhc3MsIGNoaWxkcmVuLCBhZGRvbnNBZnRlciwgLi4ucHJvcHN9ID0gdGhpcy5wcm9wcztcbiAgICAgICAgY29uc3QgZmllbGQgPSA8ZGl2IHsuLi5wcm9wc30+XG4gICAgICAgICAgICB7Y2hpbGRyZW59XG4gICAgICAgIDwvZGl2PjtcblxuICAgICAgICByZXR1cm4gdGhpcy5yZW5kZXJGaWVsZFdpdGhBZGRvbnMoZmllbGQsIGFkZG9uc0JlZm9yZSwgYWRkb25zQWZ0ZXIpO1xuICAgIH1cbn1cbmV4cG9ydCBkZWZhdWx0IFN0YXRpY0ZpZWxkO1xuIl19